export default __webpack_public_path__ + "static/media/sflex_thumb_home_2.b48a12fa.png";